<div class="city-container">
    <!-- <i class="far fa-map-marker-alt"></i> -->
    <select class="select" id="slected_city">
        <option [value]="city" *ngFor="let city of cities; let i = index" [selected]="city == selectedCity">{{city}}
        </option>
    </select>
</div>